import { Box, Divider, Typography } from '@mui/material';

export type InformationListProps = {
  title?: string;
  items: { label: string; value?: string }[];
};

/**
 * InformationList component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {InformationListProps} informationListProps - The props for the InformationList component
 * @returns {ReactElement} The InformationList component
 */

export const InformationList = ({ title, items }: InformationListProps) => {
  const NO_VALUE_PLACEHOLDER = '-';
  return (
    <>
      <Box sx={{ display: 'grid', gap: (theme) => theme.spacing(1.5) }}>
        {title && (
          <Typography
            variant="h6"
            component="h2"
            sx={{ paddingBottom: (theme) => theme.spacing(3) }}
          >
            {title}
          </Typography>
        )}

        {items?.map((item) => {
          const { value, label } = item;
          return (
            <div>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingBottom: (theme) => theme.spacing(1.5),
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: '5px',
                  }}
                >
                  <Typography>{label}</Typography>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    style={{
                      maxWidth: '100%',
                    }}
                    noWrap
                    fontWeight={500}
                  >
                    {value && value.length > 0 ? value : NO_VALUE_PLACEHOLDER}
                  </Typography>
                </div>
              </Box>
              <Divider />
            </div>
          );
        })}
      </Box>
    </>
  );
};
